/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

export const spotifyClientId: string = "" as const;
